import { useState, useEffect } from "react";
import InputNumber from "../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../shared/components/inputs/InputText/InputText";
import InputSelect from "../../../../shared/components/inputs/InputSelect/InputSelect";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useLoading } from "../../../../shared/context/LoadingContext";
import toast from "react-hot-toast";
import "./ModalDespesaRecorrente.scss";
import moment from "moment";

import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import {
  opcoesDeCaixa,
  caixaParaMetodo,
  metodoParaCaixa,
} from "../../../../shared/util/caixaEMetodo";

const formasPagamento = [
  "Dinheiro",
  "Cheque",
  "Cheque Visado",
  "Transferência de crédito",
  "Internet banking",
  "Cartão do banco",
  "Débito direto da conta bancária",
  "Cartão de crédito",
  "Cartão de débito",
];

function ModalEditarDespesaRecorrente({
  openModalDespesaRecorrente,
  handleCloseModalDespesaRecorrente,
  sendRequest,
  clinicaId,
  updateDespesasRecorrentes,
  auth,
  despesaRecorrenteFiltrada,
}) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(openModalDespesaRecorrente);
  const [descricao, setDescricao] = useState(
    despesaRecorrenteFiltrada.descricao,
  );
  const [valor, setValor] = useState(despesaRecorrenteFiltrada.valor);
  const [observacao, setObservacao] = useState(
    despesaRecorrenteFiltrada.observacao,
  );
  const [categoria, setCategoria] = useState(
    despesaRecorrenteFiltrada.categoria._id,
  );
  const [categorias, setCategorias] = useState([]);
  const [caixa, setCaixa] = useState(despesaRecorrenteFiltrada.caixa._id);
  const [caixas, setCaixas] = useState([]);

  const [despesaPaga, setDespesaPaga] = useState(
    despesaRecorrenteFiltrada.despesaPaga,
  );

  const [metodoPagamento, setMetodoPagamento] = useState(
    despesaRecorrenteFiltrada.metodoPagamento
      ? despesaRecorrenteFiltrada.metodoPagamento
      : formasPagamento[0],
  );

  const [dataTermino, setDataTermino] = useState(
    despesaRecorrenteFiltrada.dataTermino
      ? moment(despesaRecorrenteFiltrada.dataTermino)
      : moment().add(1, "year"),
  );

  const [listaFornecedores, setListaFornecedores] = useState([]);
  const [fornecedor, setFornecedor] = useState(
    despesaRecorrenteFiltrada.fornecedor?.id || "",
  );
  const [fornecedorTexto, setFornecedorTexto] = useState("");
  const [listaClientes, setListaClientes] = useState([]);
  const [cliente, setCliente] = useState(
    despesaRecorrenteFiltrada.cliente?.id || "",
  );
  const [tipoBeneficiario, setTipoBeneficiario] = useState(
    despesaRecorrenteFiltrada.funcionario ||
      despesaRecorrenteFiltrada.funcionarioUser
      ? "funcionario"
      : despesaRecorrenteFiltrada.cliente
        ? "cliente"
        : "fornecedor",
  );
  const [listaFuncionariosEUtilizadores, setListaFuncionariosEUtilizadores] =
    useState([]);
  const [funcionarioSelecionado, setFuncionarioSelecionado] = useState(
    despesaRecorrenteFiltrada.funcionario
      ? {
          id:
            despesaRecorrenteFiltrada.funcionario._id ||
            despesaRecorrenteFiltrada.funcionario.id,
          value: despesaRecorrenteFiltrada.funcionario.nome,
          tipo: "Funcionario",
        }
      : despesaRecorrenteFiltrada.funcionarioUser
        ? {
            id:
              despesaRecorrenteFiltrada.funcionarioUser._id ||
              despesaRecorrenteFiltrada.funcionarioUser.id,
            value:
              despesaRecorrenteFiltrada.funcionarioUser.nome ||
              despesaRecorrenteFiltrada.funcionarioUser.email,
            tipo: "User",
          }
        : null,
  );

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [
          categoriasResponse,
          caixasResponse,
          fornecedoresResponse,
          clientesResponse,
          funcionariosResponse,
          utilizadoresResponse,
        ] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/despesa/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/fornecedores/clinica/despesa/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/nomeid/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/funcionarios/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/users/ativos/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
        ]);

        // Process categorias
        const categoriasFormatted = categoriasResponse.categoriasFinanceiro.map(
          (cat) => ({
            id: cat.id,
            value: cat.categoria,
          }),
        );
        setCategorias(categoriasFormatted);

        // Process caixas
        const caixasFormatted = caixasResponse.caixas.map((cai) => ({
          id: cai.id,
          value: cai.caixa,
        }));
        setCaixas(caixasFormatted);

        // Process fornecedores
        const fornecedoresFormatted = fornecedoresResponse.fornecedores.map(
          (forn) => ({
            id: forn.id,
            value: forn.nome,
          }),
        );

        setListaFornecedores(fornecedoresFormatted);
        setListaClientes(clientesResponse.clientes);

        setListaFuncionariosEUtilizadores([
          ...funcionariosResponse.funcionarios.map((f) => ({
            id: f.id,
            value: f.nome,
            tipo: "Funcionario",
          })),
          ...utilizadoresResponse.users.map((u) => ({
            id: u.id,
            value: u.nome || u.email,
            tipo: "User",
          })),
        ]);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [auth.token, clinicaId, sendRequest]);

  useEffect(() => {
    setOpenModal(openModalDespesaRecorrente);
  }, [openModalDespesaRecorrente]);

  const descricaoChangeHandler = (value) => {
    setDescricao(value);
  };

  const valorChangeHandler = (value) => {
    setValor(value);
  };

  /* A mesma regra de «criar despesa recorrente». Ver
     `shared/util/caixaEMetodo`. */
  const metodoPagamentoChangeHandler = (valor) => {
    setMetodoPagamento(valor);
    setCaixa((atual) => caixaParaMetodo(caixas, valor, atual));
  };

  const caixaChangeHandler = (novaCaixa) => {
    setCaixa(novaCaixa);
    setMetodoPagamento((atual) =>
      metodoParaCaixa(caixas, novaCaixa, atual, formasPagamento),
    );
  };

  const guardarDespesaHandler = async () => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("observacoes", observacao ? observacao : "");
      formData.append("descricao", descricao);
      formData.append("valor", valor);
      formData.append("categoria", categoria);
      formData.append("caixa", caixa);
      formData.append("atualizadoPor", auth.userId);
      formData.append("dataTermino", moment(dataTermino).format("MM-DD-YYYY"));

      if (fornecedor) formData.append("fornecedor", fornecedor);
      if (cliente) formData.append("cliente", cliente);

      if (despesaPaga) {
        formData.append("metodoPagamento", metodoPagamento);
        formData.append("despesaPaga", true);
      } else {
        formData.append("despesaPaga", false);
      }

      if (funcionarioSelecionado) {
        if (funcionarioSelecionado.tipo === "Funcionario") {
          formData.append("funcionario", funcionarioSelecionado.id);
        } else {
          formData.append("funcionarioUser", funcionarioSelecionado.id);
        }
      }

      const despesaAdicionada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/despesasrecorrentes/${despesaRecorrenteFiltrada._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      updateDespesasRecorrentes(despesaAdicionada.despesaRecorrente, "edit");
      toast.success("Saída recorrente editada com sucesso");
      handleCloseModalDespesaRecorrente();
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
      setIsSubmitting(false);
    }
  };

  const preGuardarDespesaHandler = () => {
    if (valor === 0 || valor < 0) {
      toast.error("O valor da saída deve ser > 0");
    } else if (!descricao || descricao.trim().length === 0) {
      toast.error("Introduza uma descrição");
    } else if (!dataTermino) {
      toast.error("Introduza a data de término");
    } else if (!moment.isMoment(dataTermino) || !dataTermino.isValid()) {
      toast.error("Introduza a data de término corretamente");
    } else if (
      dataTermino.isBefore(moment(despesaRecorrenteFiltrada.dataTermino), "day")
    ) {
      toast.error(
        "A data de término não pode ser anterior à data de término original",
      );
    } else if (!isSubmitting) {
      setIsSubmitting(true);
      guardarDespesaHandler();
    }
  };

  const handleClienteChange = (value) => {
    setCliente(value);
  };

  const handleFornecedorChange = (value, isTexto = false) => {
    if (isTexto) {
      setFornecedorTexto(value);
      setFornecedor("");
    } else {
      setFornecedor(value);
      setFornecedorTexto("");
    }
  };
  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalDespesaRecorrente}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box adicionar-despesa__modal"
          id="modal__adicionar-despesa"
        >
          <h1 className="fluxo-atendimento__modal__titulo">
            Editar saída recorrente
          </h1>
          <div className="adicionar-despesa__modal__container">
            <InputText
              className="adicionar-despesa__modal__container--span2"
              label="Descrição *"
              initialValue={descricao}
              handleChange={descricaoChangeHandler}
            />
            <InputNumber
              className="adicionar-despesa__modal__container--span1"
              label="Valor *"
              initialValue={valor}
              handleChange={valorChangeHandler}
            />
            <div className="adicionar-despesa__modal__container--span2">
              <div className="customInputContainer">
                <select
                  onChange={(e) => {
                    setTipoBeneficiario(e.target.value);
                    setCliente("");
                    setFornecedor("");
                    setFornecedorTexto("");
                    setFuncionarioSelecionado(null);
                  }}
                  className="customInputSelect"
                  value={tipoBeneficiario}
                >
                  <option value="fornecedor">Fornecedor</option>
                  <option value="cliente">Cliente</option>
                  <option value="funcionario">Funcionário</option>
                </select>
                <label className="customInputLabelSelect">
                  Tipo de Beneficiário
                </label>
              </div>
            </div>

            {tipoBeneficiario === "fornecedor" && listaFornecedores && (
              <div
                className="adicionar-despesa__modal__container--span2"
                style={{ position: "relative" }}
              >
                <Autocomplete
                  className="saida__autocomplete"
                  freeSolo
                  options={listaFornecedores}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.value
                  }
                  value={
                    fornecedor
                      ? listaFornecedores.find((f) => f.id === fornecedor) ||
                        null
                      : fornecedorTexto || null
                  }
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string")
                      handleFornecedorChange(newValue, true);
                    else if (newValue && newValue.id)
                      handleFornecedorChange(newValue.id, false);
                    else handleFornecedorChange("", false);
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (event?.type === "change") {
                      const opcaoExistente = listaFornecedores.find(
                        (f) => f.value === newInputValue,
                      );
                      if (opcaoExistente)
                        handleFornecedorChange(opcaoExistente.id, false);
                      else handleFornecedorChange(newInputValue, true);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Fornecedor"
                      variant="outlined"
                    />
                  )}
                />
              </div>
            )}

            {tipoBeneficiario === "cliente" && listaClientes && (
              <div className="adicionar-despesa__modal__container--span2">
                <Autocomplete
                  className="saida__autocomplete"
                  freeSolo
                  options={listaClientes}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.nome
                  }
                  value={listaClientes.find((c) => c.id === cliente) || null}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string")
                      handleClienteChange(newValue);
                    else if (newValue && newValue.id)
                      handleClienteChange(newValue.id);
                    else handleClienteChange("");
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (event?.type === "change")
                      handleClienteChange(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Cliente" variant="outlined" />
                  )}
                />
              </div>
            )}

            {tipoBeneficiario === "funcionario" && (
              <div className="adicionar-despesa__modal__container--span2">
                <Autocomplete
                  className="saida__autocomplete"
                  options={listaFuncionariosEUtilizadores}
                  getOptionLabel={(option) => option.value || ""}
                  groupBy={(option) =>
                    option.tipo === "Funcionario"
                      ? "Funcionários"
                      : "Utilizadores do Sistema"
                  }
                  value={funcionarioSelecionado}
                  onChange={(event, newValue) =>
                    setFuncionarioSelecionado(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Funcionário"
                      variant="outlined"
                    />
                  )}
                />
              </div>
            )}

            {categorias && categoria && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <select
                  onChange={(e) => setCategoria(e.target.value)}
                  className="customInputSelect"
                  value={categoria}
                >
                  {categorias &&
                    categoria &&
                    categorias.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Categoria</label>
              </div>
            )}

            {caixas && caixa && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <select
                  onChange={(e) => caixaChangeHandler(e.target.value)}
                  className="customInputSelect"
                  value={caixa}
                >
                  {/* A caixa que a recorrência já tem fica sempre na lista,
                      mesmo que seja anterior à regra. */}
                  {(despesaPaga
                    ? opcoesDeCaixa(caixas, metodoPagamento, caixa)
                    : caixas
                  ).map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.value}
                    </option>
                  ))}
                </select>
                <label className="customInputLabelSelect">Caixa</label>
              </div>
            )}

            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-despesa__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data de término*"
                inputFormat="DD-MM-YYYY"
                value={dataTermino}
                minDate={moment(despesaRecorrenteFiltrada.dataTermino)} // ✓ Não permite escolher data anterior
                onChange={(value) => setDataTermino(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <textarea
              cols="30"
              rows="7"
              placeholder="observacao"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              className="adicionar-despesa__modal__container__textarea"
            ></textarea>
          </div>

          <div className="adicionar-despesa__modal__container__checkbox-pago__container">
            <input
              type="checkbox"
              name=""
              id="ja-foi-pago-checkbox"
              onChange={(e) => setDespesaPaga(e.target.checked)}
              checked={despesaPaga}
            />
            <label htmlFor="ja-foi-pago-checkbox">
              Essa saída fica como paga
            </label>
          </div>

          {despesaPaga && (
            <div className="adicionar-despesa__modal__pagamento">
              <InputSelect
                label="Forma de pagamento"
                initialValue={metodoPagamento}
                handleChange={metodoPagamentoChangeHandler}
                items={formasPagamento}
              />
            </div>
          )}
          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalDespesaRecorrente}
              style={{ display: "block" }}
            >
              Fechar
            </span>

            <span
              disabled={isSubmitting}
              className="blue-button"
              onClick={preGuardarDespesaHandler}
            >
              {isSubmitting ? "Guardando..." : "Guardar"}
            </span>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ModalEditarDespesaRecorrente;
